import React, { useState, useRef } from "react";
import { SportsSoccer, FormatColorTextSharp, PhotoSharp, VolumeOff, VolumeUp } from '@mui/icons-material';

const iconMap = {
  SportsSoccer,
  FormatColorTextSharp,
  PhotoSharp,
  VolumeOff,
  VolumeUp,
};

export default function BlogViewToggle({ value, onChange, onViewStateChange, color = "black", color2 = "black", fontSize = 12,
  icon1 = "FormatColorTextSharp", 
  icon2 = "PhotoSharp",
  caption = false
 }) {
  const Icon1 = iconMap[icon1];
  const Icon2 = iconMap[icon2];
  
  const [isPlaying, setIsPlaying] = useState(!!value);
  const videoRef = useRef(null);
  const [videoVisible, setVideoVisible] = useState(false);
  const [viewState, setViewState] = useState(0);

  const marginSize = 40;

  const handleToggle = () => {
    // Detect mobile device
    const isMobile = typeof window !== 'undefined' && /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    const animationDelay = isMobile ? 900 : 500;

    if (videoRef.current) {
      videoRef.current.currentTime = 0;
      videoRef.current.play();

      // avoid flick
      setTimeout(() => {
        setVideoVisible(true);
      }, 200);
    }
    // Update toggle state immediately (true/false)
    const next = !isPlaying;
    setIsPlaying(next);
    if (onChange) onChange(next);
    // Delay the soccer ball animation (0/1)
    setTimeout(() => {
      requestAnimationFrame(() => {
        const newViewState = next ? 1 : 0;
        setViewState(newViewState);
        if (onViewStateChange) onViewStateChange(newViewState);
      });
    }, animationDelay);
  };

  
  return (
    <>
      <style>{`
        .soccer-anim {
          position: absolute;
          top: 50%;
          left: 0;
          transform: translateY(-50%) rotate(0deg);
          transition: left 0.7s cubic-bezier(.4,2,.6,1), right 0.7s cubic-bezier(.4,2,.6,1), transform 0.7s cubic-bezier(.4,2,.6,1);
        }
        .soccer-anim.right {
          left: unset;
          right: 0;
          transform: translateY(-50%) rotate(360deg);
        }
        .soccer-anim.left {
          left: 0;
          right: unset;
          transform: translateY(-50%) rotate(0deg);
        }
      `}</style>
      <div style = { { width : "100%", paddingBottom : "16px" } }>
      <button className="blog-view-toggle"
          onClick={handleToggle}
          style={{ overflow: "visible" }}
          >
        <div
          className = "soccerBallToggleContainer"
            style = { {
              position : "relative",
              height : "40px",
              // background :"red",
            } }>
          <video
            ref={videoRef}
            src="/assets/test.mov"
            controls={false}
            playsInline
            webkit-playsinline="true"
            style={{
              position: "absolute",
              top: 0,
              height: "100%",
              width: "auto",
              display: videoVisible ? "block" : "none",
              right: isPlaying ? undefined : 0,
              left: isPlaying ? 0 : undefined,
              transform: isPlaying ? "scaleX(-1)" : "none"
            }}
            // onPlay={() => setVideoVisible(true)}

            onEnded={e => {
              e.target.pause();
              setVideoVisible(false);
            }}
            // onPause={() => setVideoVisible(false)}
          />

          {/* Soccer ball icon that animates left <-> right and spins */}
          <div
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              top: "50%",
              left: 0,
              transform: "translateY(-50%)",
              pointerEvents: "none",
              // overflow: "hidden",
              // background : "blue",
            }}
          >
            <span
              className="soccerBall"
              style={{
                position: "absolute",
                left: viewState === 1
                  ? `calc(100% - ${marginSize}px - ${fontSize}px)`
                  : `${marginSize}px`,
                transition: "left 0.7s cubic-bezier(0.4, 1.5, 0.2, 1), transform 0.7s cubic-bezier(0.4, 1.7, 0.2, 1)",
                transform: `rotate(${viewState === 1 ? 720 : 0}deg)`,
                zIndex: 100,
                bottom: 0
              }}
            >
              <SportsSoccer style = { { fontSize: fontSize, fill : color } } />
            </span>
          </div>
          </div>

          <div style = { { display: "flex", flexDirection: "row", alignItems: "flex-start", width : "100%", background : "", height : "16px",
            gap : "16px",
            padding : `0px ${marginSize}px`,
           } }>
            <div style={ { display : "flex", flexDirection : 'column', position : "relative" } }>
              <Icon1 style={{ fontSize: fontSize, fill : color2 }} />
              { caption && <p style = { { fontSize : "var(--font-size-teeny)", color : color2, position : "absolute", top : 24, left : -fontSize * 0.5, zIndex : 9999, textAlign : "center", lineHeight : 1 } }>Sound Off</p> }
            </div>
          
            <div style = { { height : "1px", background : "var(--black8)", width : "100%" } }/>

            <div style={ { display : "flex", flexDirection : 'column', position : "relative" } }>
              <Icon2 style={{ fontSize: fontSize, fill : color2 }} />
              { caption && <p style = { { fontSize : "var(--font-size-teeny)", color : color2, position : "absolute", top : 24, left : -fontSize * 0.5, zIndex : 9999, textAlign : "center", lineHeight : 1 } }>Sound On</p> }
            </div>
          </div>

          </button>
          </div>
    </>
  );
}